import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import api from "../../../utils/apiClient";
import Toast from '../../Shared/Toast/Toast';
import APIConstant from "../../../utils/pathConstants";
import GraceMarksCardDialog from "./GraceMarksCard";
import Loader from "../../Shared/Loader/Loader";
import { useCatchResponse } from '../../../utils/useCatchResponse';

const GraceMarksEntry = (props) => {
    const { catchResponse } = useCatchResponse();
    const [students, setStudents] = useState([]);
    const navigate = useNavigate();
    const [currentStudentIndex, setCurrentStudentIndex] = useState(0);

    useEffect(() => {
        GetGradeMarksList();
    }, []);

    const GetGradeMarksList = async () => {
        try {
            Loader.show();
            let data = {
                ClassId: props?.location?.state?.classId,
                TermId: props?.location?.state?.termId
            };
            const response = await api.post(APIConstant.path.GetGraceMarksEntryList, data);
            if (response.success) {
                setStudents(response.data);
            }
            Loader.hide();
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    };

    const handleNext = () => {
        if (currentStudentIndex < students.length - 1) {
            setCurrentStudentIndex(currentStudentIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (currentStudentIndex > 0) {
            setCurrentStudentIndex(currentStudentIndex - 1);
        }
    };

    const handleMarkUpdate = (studentId, index, subject, markValue) => {
        var formatedData = students.map((student) =>
            student.StudentId === studentId
                ? {
                    ...student,
                    SubjectList: student?.SubjectList.map((grade, gradeIndex) =>
                        gradeIndex === index && grade?.SubjectId === subject
                            ? {
                                ...grade,
                                GraceMarks: markValue
                            }
                            : grade
                    ),
                }
                : student
        );
        setStudents(formatedData);
    };

    const AddGradeEntryData = async (isGraft) => {
        try {
            const updatedStudents = students?.map((student) => (
                { ...student, IsGraft: isGraft })
            );
            await api.post(APIConstant.path.AddUpdateGradingEntry, updatedStudents).then(async response => {
                let res = response;
                if (res.success) {
                    Toast.success({ message: res.message });
                    navigate('/grace-mark')
                }
            }).catch(err => {
                console.log(err);
                catchResponse(err);
            });
        } catch (err) { console.log(err);
            catchResponse(err);
         }
    };

    return (
        <div className="wayment-owner-dashboard e-weighment-dashboard">
            <div className="heading-area flex justify-between items-center">
                <div className="flex items-center">
                    <i className="pi pi-arrow-left" onClick={() => navigate('/grace-mark')}></i>
                    <h2 className="ml-2">{props?.location?.state?.className}</h2>
                </div>
            </div>
            <hr />
            {students.length > 0 && (
                <GraceMarksCardDialog student={students[currentStudentIndex]} onMarkeChange={handleMarkUpdate} />
            )}
            <div className="flex justify-between mt-4">
                <Button
                    label="Previous"
                    className="p-button-secondary"
                    onClick={handlePrevious}
                    disabled={currentStudentIndex === 0}
                />
                <div className="flex justify-end gap-3 mt-4">
                    <Button label="Cancel" onClick={(e) => navigate('/grace-mark')} className="p-button-outlined p-button-secondary" />
                    <Button label="Save as Draft" className="p-button-secondary" onClick={(e) => AddGradeEntryData(true)} />
                    <Button label="Submit All" className="p-button-primary" onClick={(e) => AddGradeEntryData(false)} />
                </div>
                <Button
                    label="Next"
                    className="p-button-secondary"
                    onClick={handleNext}
                    disabled={currentStudentIndex === students.length - 1}
                />
            </div>
        </div>
    );
};

export default GraceMarksEntry;
